/**
 * webhooks-crud
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RetryConfiguration } from './retry-configuration';
import { Node } from '../tree-node.model';
import { PlaybookActionType } from './playbook-event';

export enum LastRunStatus {
  NotRun = 'NotRun',
  Succeeded = 'Succeeded',
  Failed = 'Failed'
}

export interface Step {
  /**
   * (PRIMARY KEY) a random UUID defines this playbook flow
   */
  step_id?: string;
  /**
   * The name of the step given by the user
   */
  step_title?: string;
  /**
   * ID of the playbook definition associated with this step
   */
  playbook_id?: string;
  /**
   * ID of event that this step subscribes to. The ID can be either an internal platform event or the ID of the previous step
   */
  step_trigger_event?: string;
  /**
   * The URL of the step HTTP POST request
   */
  step_url_to_trigger?: string;
  /**
   * The action type needs to be performed
   */
  step_action_type?: PlaybookActionType;
  /**
   * Is this an internal action step or not
   */
  is_internal?: boolean;
  /**
   * A JSON-like filter configuration that is used to filter events based on their payload
   */
  filter_configuration?: Node<any, any>;
  /**
   * A JSON-like payload manipulation configuration that is used for generating the payload for the POST HTTP request based on the event’s data
   */
  payload_configuration?: any;
  /**
   * A JSON-like configuration that is used for generating the headers for the POST HTTP request
   */
  headers_configuration?: any;
  /**
   * Holds the retry mechanism configurations
   */
  retry_configuration?: RetryConfiguration;
  /**
   *  Whether the last step was successfully run
   */
  last_run_status?: LastRunStatus;

  /**
   * The timestamp of the last step run
   */
  last_run_timestamp?: string;
  
  enable_action_dropdown?: boolean;
  enable_trigger_dropdown?: boolean;
}
